var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4399 1.81011L12.5532 0.696777L13.9665 2.11011L12.8532 3.22344L11.4399 1.81011ZM10.7732 2.47678L12.1865 3.89011L8.1132 7.96344H6.69987V6.55678L10.7732 2.47678ZM9.4532 2.39011L5.69987 6.14344V8.97011H8.52654L12.2732 5.22344C12.5465 5.88344 12.6999 6.62344 12.6999 7.43678C12.6999 9.65011 10.9199 12.2701 7.36654 15.3034C3.8132 12.2701 2.0332 9.65011 2.0332 7.43678C2.0332 4.11678 4.56654 1.97011 7.36654 1.97011C8.0932 1.97011 8.80654 2.11678 9.4532 2.39011Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLocation);
export default __webpack_public_path__ + "static/media/edit_location.f08a332713eb762a830c1bc6d18f283b.svg";
export { ForwardRef as ReactComponent };